import Vue from "vue";

let getHsl = (h, s, l) => {
  return "hsl(" + h + "deg " + s + "% " + l + "%);";
};

let get3DBorder = (h, s, l, b) => {
  let output =
    ";padding:" +
    (b + 1 + "px ") +
    (b + 6 + "px ") +
    (b + "px ") +
    (b + 6 + "px;") +
    (";background:" + getHsl(h, s, l)) +
    (";border:" + b + "px solid " + getHsl(h, s, l + 15)) +
    (";border-right:" + (b + 1) + "px solid " + getHsl(h, s, l - 15)) +
    (";border-bottom:" + (b + 1) + "px solid " + getHsl(h, s, l - 15));
  return output;
};

window.containsNumber = (text) => {
  return /\d/.test(text);
};

window.containsUrl = (text) => {
  if (text.toString().includes("http")) return true;
  return false;
};

window.getVueName = (e) => {
  if (e && e.$options && e.$options.__file) return e.$options.__file.split("\\").pop().split("/").pop().split(".")[0];
};

window.getVueFileName = (e) => {
  if (e && e.$options && e.$options.__file) return e.$options.__file;
};

let log = (background, color, ...messages) => {
  let styleBackground = ";padding:4px 8px 3px 8px;margin:4px 0px 8px 0px;background:" + background;
  let styleColor = ";color:" + color;
  let titleLog = "";
  let logs = [];
  messages.forEach((msg) => {
    if (typeof msg == "string" && !window.containsUrl(msg) && !titleLog.length) {
      titleLog = msg;
    } else {
      logs.push(msg);
    }
  });
  console.log("%c" + titleLog.toUpperCase(), styleBackground + styleColor, ...logs);
};

Vue.prototype.reload = () => window.location.reload();
Vue.prototype.log = window.log = (...messages) => log(getHsl(220, 75, 60), "white", ...messages);
Vue.prototype.logGreen = window.logGreen = (...messages) => log(getHsl(120, 100, 28), "white", ...messages);
Vue.prototype.logOrange = window.logOrange = (...messages) => log(getHsl(28, 80, 50), "white", ...messages);
Vue.prototype.logRed = window.logRed = (...messages) => log(getHsl(360, 70, 40), "white", ...messages);

window.setThemeColor = (color) => {
  let convert = require("color-convert");
  let colorHSL = window.containsNumber(color) ? convert.hex.hsl(color) : convert.keyword.hsl(color);

  if (colorHSL && colorHSL.length) {
    window.document.styleSheets[0].deleteRule(0);
    window.document.styleSheets[0].insertRule(":root{--h:" + colorHSL[0] + ";--s:" + colorHSL[1] + "%;}", 0);
  }
};

// window.setThemeColor("firebrick");
// window.setThemeColor("forestgreen");
// window.setThemeColor("#44a5e0");
// window.setThemeColor("purple");
// window.setThemeColor("blueviolet");
// window.setThemeColor("teal");

window.logMoovit = (appTitle, left) => {
  console.log(
    "\n%c" +
      "███████████    ██████    ██████   ██     ██  ▒▒  ▒▒▒▒▒▒  \n" +
      "██   ██   ██  ██    ██  ██    ██   ██   ██   ▒▒    ▒▒    \n" +
      "██   ██   ██  ██    ██  ██    ██    ██ ██    ▒▒    ▒▒    \n%c" +
      "▓▓   ▓▓   ▓▓   ▓▓▓▓▓▓    ▓▓▓▓▓▓      ▓▓▓     ▒▒    ▒▒    \n%c" +
      "B r o a d c a s t   I T   S o l u t i o n s\n" +
      (appTitle ? "%c" + appTitle : ""),
    "font-size:14px;font-weight:900",
    "font-size:14px;font-weight:900;color:#44a5e0;margin-bottom:10px",
    "font-size:26px;font-weight:900;font-family:Ubuntu,sans-serif;margin:0 0 12px 24px;",
    appTitle
      ? "font-size:26px;font-weight:500;font-family:Ubuntu,sans-serif;color:yellow;margin:0 0 12px 24px;margin-left:" +
          (left ? left : "75") +
          "px;" +
          get3DBorder(203, 71, 57, 3)
      : "",
    "\n\n"
  );
};
